var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.238281,
    width: 27.1194,
    height: 26,
    rx: 13,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7969 7.31055C13.7969 7.31055 19.102 7.31024 20.4287 7.6582C21.1547 7.8456 21.7274 8.39478 21.9229 9.09082C22.2849 10.3592 22.2716 12.9994 22.2715 13.0127C22.2715 13.0127 22.2718 15.6491 21.9229 16.9209C21.7274 17.6169 21.1547 18.1661 20.4287 18.3535C19.1021 18.6881 13.7969 18.6885 13.7969 18.6885C13.7632 18.6885 8.50108 18.6868 7.16504 18.3398C6.4392 18.1524 5.86638 17.6041 5.6709 16.9082C5.32186 15.65 5.32227 12.999 5.32227 12.999C5.32228 12.9649 5.32417 10.3541 5.6709 9.09082C5.86634 8.39486 6.4531 7.83297 7.16504 7.64551C8.48716 7.31194 13.7632 7.31055 13.7969 7.31055ZM12.1074 15.4355L16.5195 13L12.1074 10.5635V15.4355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhiteIcon);
export default __webpack_public_path__ + "static/media/youtube_white-icon.1ff95a16b0b19adbf754714f4c82f5e1.svg";
export { ForwardRef as ReactComponent };